import { Router } from '@angular/router'
import { Map } from 'immutable'

export default abstract class ListTrait {
  public state: Map<string, any>
  public filterTimeout: any
  constructor(public router: Router) {}

  getQueryParam(name: string) {
    const field = this.state.getIn(['queryParams', name])
    return typeof field !== 'undefined' ? field : ''
  }

  getPagination(name: string) {
    const field = this.state.getIn(['pagination', name])
    return typeof field !== 'undefined' ? field : ''
  }

  handleSort(prop: string) {
    let queryParams = this.state.get('queryParams')

    console.log(queryParams.toJS())

    if (queryParams) {
      if (
        (queryParams.get('sort') === 'asc' ||
          queryParams.get('sort') === 'ASC') &&
        queryParams.get('order_by') === prop
      ) {
        queryParams = queryParams.set('sort', 'desc')
      } else if (
        (queryParams.get('sort') === 'desc' ||
          queryParams.get('sort') === 'DESC') &&
        queryParams.get('order_by') === prop
      ) {
        queryParams = queryParams.delete('order_by').delete('sort')
      } else {
        queryParams = queryParams.set('sort', 'asc').set('order_by', prop)
      }

      queryParams = queryParams.toJS()

      this.router.navigate([location.pathname], {
        queryParams,
      })
    } else {
      const pagination = this.state.get('pagination').toJS()
      const filters = this.state.get('filters').toJS()
      let sort: string
      let order_by: string

      if (pagination.sort === 'asc' && pagination.order_by === prop) {
        sort = 'desc'
        order_by = prop
      } else if (pagination.sort === 'desc' && pagination.order_by === prop) {
        sort = undefined
        order_by = undefined
      } else {
        sort = 'asc'
        order_by = prop
      }

      if (this.handleFilterChange) {
        this.handleFilterChange({
          filters,
          pagination: { ...pagination, sort, order_by },
        })
      }
    }
  }

  handleFilterChange(e: any) {
    clearInterval(this.filterTimeout)

    this.filterTimeout = setTimeout(() => {
      const queryParams = this.state
        .get('queryParams')
        .set(
          e.target.name,
          e.target.type === 'checkbox' ? e.target.checked : e.target.value,
        )
        .set('page', 1)
        .toJS()

      this.router.navigate([location.pathname], {
        queryParams,
      })
    }, 800)
  }

  handlePageChange(page: any) {
    if (this.state.get('queryParams')) {
      const queryParams = this.state
        .get('queryParams')
        .set('page', parseInt(page, 10))
        .toJS()

      this.router.navigate([location.pathname], {
        queryParams,
      })
    } else {
      const pagination = this.state.get('pagination').toJS()
      const filters = this.state.get('filters').toJS()

      this.handleFilterChange({
        filters,
        pagination: { ...pagination, page: parseInt(page, 10) },
      })
    }
  }

  handlePageSizeChange(itemsPerPage: any) {
    if (this.state.get('queryParams')) {
      const queryParams = this.state
        .get('queryParams')
        .set('page_size', parseInt(itemsPerPage, 10))
        .toJS()

      this.router.navigate([location.pathname], {
        queryParams,
      })
    } else {
      const pagination = this.state.get('pagination').toJS()
      const filters = this.state.get('filters').toJS()

      this.handleFilterChange({
        filters,
        pagination: { ...pagination, page_size: parseInt(itemsPerPage, 10) },
      })
    }
  }
}
